export enum LDFlags {
  SHOW_SERVICE_REQUEST_ESTIMATE = 'showServiceRequestEstimate',
  SHOW_SERVICE_REQUEST_DYNAMIC_FORMS = 'showServiceRequestDynamicForms',
  SHOW_RECURRING_SCHEDULED_SERVICE_REQUEST_FIELDS = 'showRecurringScheduledServiceRequestFields',
  SHOW_SERVICE_REQUEST_REPORT_ON_BEHALF_OF_FIELD = 'showServiceRequestReportOnBehalfOfField',
  SHOW_FLOOR_PLAN_PINNING = 'showFloorPlanPinning',
  MESSAGE_FEED_ENABLED = 'messageFeedEnabled',
  SHOW_SERVICE_REQUESTS_FEEDBACK = 'showServiceRequestsFeedback',
}
